<template>
  <span v-if="user" class="mini-user-display">
    <span class="mini-user-profile-image">
      <user-avatar :name="user.display_name || user.twitch_name" :src="user.profile_image_url" />
    </span>
    <span class="mini-user-name">{{user.display_name}}</span>
  </span>
</template>

<script>
import UserAvatar from './User-Avatar'

export default {
  name: 'User',
  components: {
    UserAvatar
  },
  props: ['user_id'],
  async created () {
    // console.log('FETCHING', this.user_id)
    this.fetched = true
    this.$store.dispatch('fetchUser', this.user_id)
  },
  data () {
    return {
      users: this.$store.state.users,
      fetched: false
    }
  },
  computed: {
    user () {
      return this.users[this.user_id.toLowerCase()]
    }
  }
}
</script>

<style scoped>
.mini-user-display {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  max-width: 100%;
  vertical-align: middle;
}

.mini-user-profile-image {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid var(--sl-line-strong);
  box-sizing: border-box;
  overflow: hidden;
  display: block;
}

.mini-user-name {
  font-weight: 600;
  font-size: 15.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue